import { render, staticRenderFns } from "./PriceUpFormUpdate.vue?vue&type=template&id=2c515988&scoped=true&"
import script from "./PriceUpFormUpdate.vue?vue&type=script&lang=js&"
export * from "./PriceUpFormUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PriceUpFormUpdate.vue?vue&type=style&index=0&id=2c515988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c515988",
  null
  
)

export default component.exports